import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import alumniApi from "../../config/alumniApi";
import { useAlumniAuth } from "../../contexts/AlumniAuthContext";
import styles from "./AlumniAuth.module.css";

const AlumniLogin = () => {
  const navigate = useNavigate();
  const { login } = useAlumniAuth();

  const [step, setStep] = useState("MOBILE"); // MOBILE | OTP
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [info, setInfo] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSendOtp = async (e) => {
    e.preventDefault();
    setError("");
    setInfo("");

    if (!/^[6-9]\d{9}$/.test(mobile)) {
      setError("Enter a valid 10-digit mobile number");
      return;
    }

    setLoading(true);
    try {
      await alumniApi.post("/alumni/auth/send-otp", { mobile_number: mobile, purpose: "LOGIN" });
      setInfo("OTP sent to your registered mobile number.");
      setStep("OTP");
    } catch (err) {
      setError(err.response?.data?.error || "Failed to send OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    setError("");

    if (otp.length !== 6) {
      setError("Enter the 6-digit OTP");
      return;
    }

    setLoading(true);
    try {
      const { data } = await alumniApi.post("/alumni/auth/verify-otp", {
        mobile_number: mobile,
        otp,
      });
      login({ token: data.token, alumni: data.alumni });
      navigate("/alumni/dashboard", { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || "Invalid OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <h1 className={styles.title}>Alumni Portal Login</h1>
        <p className={styles.subtitle}>
          Log in with your registered mobile number to access your alumni profile.
        </p>

        {error && <div className={styles.error}>{error}</div>}
        {info && <div className={styles.success}>{info}</div>}

        {step === "MOBILE" && (
          <form onSubmit={handleSendOtp}>
            <div className={styles.field}>
              <label className={styles.label} htmlFor="mobile">Mobile Number</label>
              <input
                id="mobile"
                className={styles.input}
                type="tel"
                maxLength={10}
                placeholder="10-digit mobile number"
                value={mobile}
                onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
                required
              />
            </div>
            <button type="submit" className={styles.button} disabled={loading}>
              {loading ? "Sending OTP..." : "Send OTP"}
            </button>
          </form>
        )}

        {step === "OTP" && (
          <form onSubmit={handleVerifyOtp}>
            <div className={styles.field}>
              <label className={styles.label} htmlFor="otp">Enter OTP</label>
              <input
                id="otp"
                className={styles.input}
                type="text"
                inputMode="numeric"
                maxLength={6}
                placeholder="6-digit OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
                required
              />
            </div>
            <button type="submit" className={styles.button} disabled={loading}>
              {loading ? "Verifying..." : "Verify & Login"}
            </button>
            <div className={styles.footerRow}>
              <button
                type="button"
                className={styles.linkBtn}
                onClick={() => {
                  setStep("MOBILE");
                  setOtp("");
                }}
              >
                Change number
              </button>
              <button type="button" className={styles.linkBtn} onClick={handleSendOtp}>
                Resend OTP
              </button>
            </div>
          </form>
        )}

        <div className={styles.footerRow}>
          <span>New alumnus?</span>
          <Link to="/alumni/register" className={styles.linkBtn}>Request registration</Link>
        </div>
      </div>
    </div>
  );
};

export default AlumniLogin;
